<div>
    <div class="notification-with-dismiss">
        <span class="notification">{{ prependMessage }}<a (click)="dimissAfterTimedInterval(1000)" href="tel: {{ phoneNumber | fullyQualifyPhoneNumber:isoCountryCode }}">{{ phoneNumber | formatPhoneNumber:isoCountryCode:formatAs }}</a>{{ appendMessage }}
            <span class="dismiss" (click)="dismiss()"><strong>Dismiss</strong></span>
        </span>
    </div>
    <div class="clear"></div>
</div>